// extracted by mini-css-extract-plugin
export default {"mainContainer":"no_bookings_screen-module___mainContainer___d67fd770","top":"no_bookings_screen-module___top___e4f2dc5c"};